import { FETCH_EZEETUNAI_BALANCE, IS_NEW_LOADING, FETCH_USERS_REQUEST} from "../../ActionType/actionTypes";

const initialState = {
    getBalance: {},
    loading : true
}

const ezeeTunaiGetBalanceReducer = (state=initialState, action) => {
    switch(action.type) {
        case FETCH_USERS_REQUEST : 
        return{
            ...state,
            loading: true
        }
        case FETCH_EZEETUNAI_BALANCE : 
        return{
            ...state,
            loading: false,
            getBalance : action.payload 
        }
        case IS_NEW_LOADING : 
        return{ 
            ...state,           
            loading : true
        }
        default : return state
    }
}

export default ezeeTunaiGetBalanceReducer